import React from 'react';
import { Box, Button, MenuItem, Select, Typography } from '@mui/material';

const Pagination = ({ offset, limit, totalResults, onPageChange, onLimitChange }) => {

  const totalPages = Math.ceil(totalResults / limit);
  const currentPage = Math.floor(offset / limit) + 1;

  const handlePrevPage = () => {
    if (currentPage > 1) {
      onPageChange((currentPage - 2) * limit);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage * limit);
    }
  };

  const handleLimitChange = (event) => {
    onLimitChange(event.target.value);
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 2, mb : 3 }}>
      <Button onClick={handlePrevPage} disabled={currentPage === 1}>
        Préc.
      </Button>
      <Typography sx={{ mx: 2 , whiteSpace: 'nowrap',}}>
        {currentPage} / {totalPages}
      </Typography>
      <Button onClick={handleNextPage} disabled={currentPage === totalPages}>
        Suiv.
      </Button>
      <Select
        value={limit}
        onChange={handleLimitChange}
        sx={{ ml: 2 }}
      >
        {[1, 10, 20, 50, 100].map(size => (
          <MenuItem key={size} value={size}>
            {size} par page
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export default Pagination;